import { useEffect, useState } from "react"
import { Button, Col, FormControl, FormLabel, ListGroupItem, Row } from "react-bootstrap";
import { MdClose } from "react-icons/md"
import AreYouSureModal from "../AreYouSureModal";
import PrivateApi from "../../../services/PrivateApiService";
import { useQueryClient } from "react-query";

const EmployeeListItem = ({employee, openId, setOpenId}) => {

    const API = new PrivateApi();
    const queryClient = useQueryClient();
    const [editableEmployee, setEditableEmployee] = useState(employee);
    const [isOpen, setIsOpen] = useState(false);
    const [isChanged, setIsChanged] = useState(false);
    const [areYouSure, setAreYouSure] = useState(false);
    const [hide, setHide] = useState(false);

    useEffect(() => {
        if (
            editableEmployee.name !== employee.name ||
            editableEmployee.email !== employee.email ||
            (employee.mobile !== "False" && editableEmployee.mobile !== employee.mobile) ||
            (employee.mobile === "False" && editableEmployee.mobile !== "False" && editableEmployee.mobile !== "")
        ) {
            setIsChanged(true);
        } else {
            setIsChanged(false);
        }
    }, [editableEmployee, employee])


    useEffect(() => {
        if (openId !== employee.id && openId !== 0) setIsOpen(false);
    }, [openId])


    const deleteTeamMember = () => {
        API.get_Partner_employee_archive(employee.id);
        queryClient.invalidateQueries("GET_EMPLOYEES");
        setAreYouSure(false);
        setHide(true);
    }

    return (
        <>
            <ListGroupItem hidden={hide} action style={isOpen?{background: "rgb(231, 231, 231)", border: "3px solid #a2c13f"}:null}>
                <Row onClick={() => {setIsOpen(!isOpen); setOpenId(employee.id)}}>
                    <Col xl="3">{employee.name}</Col>
                    <Col xl="5">{employee.email}</Col>
                    <Col xl="3">{employee.mobile === "False"? "":employee.mobile}</Col>
                    {isOpen?
                        <Col xl="1" className="text-end">
                            <MdClose />
                        </Col>
                    :null}
                </Row>
                {isOpen ?
                    <>
                        <Row className="mt-3">
                            <Col xl="6">
                                <FormLabel>Vor- und Nachname</FormLabel>
                                <FormControl 
                                    value={editableEmployee.name} 
                                    onChange={e => setEditableEmployee(prev => ({...prev, name: e.target.value}))}
                                />
                            </Col>
                            <Col xl="6">
                                <FormLabel>E-Mail</FormLabel>
                                <FormControl 
                                    value={editableEmployee.email} 
                                    onChange={e => setEditableEmployee(prev => ({...prev, email: e.target.value}))}
                                />
                            </Col>
                        </Row>
                        <Row className="mt-3 align-items-center">
                            <Col xl="4">
                                <FormLabel>Telefonnummer</FormLabel>
                                <FormControl 
                                    value={editableEmployee.mobile === "False"? "": editableEmployee.mobile} 
                                    onChange={e => setEditableEmployee(prev => ({...prev, mobile: e.target.value}))}
                                />
                            </Col>
                            <Col xl="8" className="text-end">
                                <Button onClick={() => setAreYouSure(true)} className="btn-danger">Löschen</Button>
                                {isChanged?
                                    <Button style={{marginLeft: 5}} className="btn-energo">Änderung speichern</Button>
                                :null}
                            </Col>
                        </Row>
                    </>
                :null}
            </ListGroupItem>
            <AreYouSureModal
                show={areYouSure}
                setShow={setAreYouSure}
                title={`Kontaktperson ${employee.name} löschen`}
                message={`Sind Sie sicher, dass Sie ${employee.name} als Kontaktperson löschen wollen?`}
                yesHandler={deleteTeamMember}
                loading={false}
            />
        </>
    )
}
export default EmployeeListItem;